module.exports = __webpack_public_path__ + "static/flower-5e5b6fe6359c6951abce243ac4446744.svg";